import styles from "./Programs.module.css"
import { useEffect, useState } from "react"
import moment from "moment"
import { Spinner } from "flowbite-react"
import { Playlogs } from "../playLogs/lib/playlogs";
import { usePlayers } from "../players/lib/players";
import { useStoreShared } from "../../store";
import { Program, SetActiveProgram, usePrograms } from "./lib/program";
import { setPlayersList } from "../players/store/actions";
import { uniqBy } from "lodash";
import players from "../players/Players";
import { useStorePlayers } from "../players/store";
import { useStorePrograms } from "./store";
import { setPrograms } from "./store/actions";
import { Toast } from "react-bootstrap";
import { useStorePlayer } from "../player/store";
interface Props {
  serviceName?: string
}
function Programs(props: Props) {
  const [showRedToast, setShowRedToast] = useState(false);
  const toggleShowRed = () => setShowRedToast(!showRedToast);
  const [showWarningToast, setShowWarningToast] = useState(false);
  const toggleShowWarning = () => setShowWarningToast(!showRedToast);
  const { stateShared } = useStoreShared()
  const [programs, , loadingList] = usePrograms(stateShared.currentClient?.uuid)
  const [spinner, showSpinner] = useState(false);
  const [position, setPosition] = useState(1);
  const [data , error ,loading , retry] = SetActiveProgram(stateShared.currentClient?.uuid , position , spinner );
  const { statePrograms, dispatchPrograms } = useStorePrograms();
  const { statePlayer, dispatchPlayer } = useStorePlayer()
  const [selectedProgram, setSelectedProgram] = useState("");

  function onChangeHandler(program: Program , index: number) {
    if (!showWarningToast){
      setSelectedProgram(program.name);
      setPosition(index+1);
      showSpinner(true);
      setShowRedToast(true);
      retry();
    }
  }
  const  listItems =  programs.map((program: Program , index:number) => (
    <span  className={showWarningToast ? styles.item_not_allowed : ''} key={program.name}  >
      <div className={styles.button+ " " + (selectedProgram === program.name ? styles.active : null)} onClick={() => onChangeHandler(program , index)} >
       <span className={styles.text}>{program.name}</span>
      </div>
    </span>
  ));
  useEffect(() => {
   if(!statePlayer.player?.online) {
     setShowWarningToast(true);
   }

  }, [statePlayer])
  useEffect(() => {
    console.log(programs)
    if (programs && programs.length > 0) {
      dispatchPrograms(setPrograms(uniqBy([...statePrograms.programs, ...programs], "name")))
    }

    for (let i = 0; i < programs.length; i++) {
      if ( programs[i].isActive === true ){
        setSelectedProgram(programs[i].name);
      }
    }
  }, [programs])
  useEffect(() => {
    console.log(data , error)
    showSpinner(false);
    setTimeout(() => {
      setShowRedToast(false);
    }, 5000)
  }, [loading])

  return (
    <div className={styles.root}>
      {spinner && (
        <div className={styles.BlurScreen}>
          <div className={styles.centerScreen}>
            <Spinner size="xl"></Spinner>
          </div>
        </div>
      )}
      <div className={styles.container}>{programs && listItems}
        <Toast show={showRedToast} onClose={toggleShowRed} className={styles.bottom_right }>
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Success</strong>
          </Toast.Header>
          <Toast.Body>Request sent to the player</Toast.Body>
        </Toast>
        <Toast show={showWarningToast} onClose={toggleShowWarning} className={styles.bottom_right_Warning }>
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Warning</strong>
          </Toast.Header>
          <Toast.Body>Player is offline</Toast.Body>
        </Toast>
      </div>
    </div>
  )
}

export default Programs
